import { APIBasePath } from "../../config/paths";
const baseURL = APIBasePath + "trending/";
const BrowserURLs = {
  getRedditStocks: baseURL + "reddit",
  getTwitterStocks: baseURL + "twitter",
  getAllStocks: baseURL + "all",
  getPennystocks: baseURL + "trending-pennystocks"
};

export default BrowserURLs;
